/**
 *
 * suspend wire Service Actions
 *
 */

import {
  SUSPEND_WIRE_REQUEST,
  NOT_ASKED,
  LOADING,
  SUCCESS,
  FAILURE,
} from './constants';

/**
 * Kicks off the saga that initiates the request.
 *
 */
export function suspendWireRequest(transferId, payload, action, successMessage) {
  return {
    type: SUSPEND_WIRE_REQUEST,
    transferId,
    payload,
    action,
    successMessage,
  };
}

/**
 * Used by the saga to set the status.
 */
export function notAsked() {
  return {
    type: NOT_ASKED,
  };
}

/**
 * Used by the saga to set the status and store params.
 */
export function loading(transferId) {
  return {
    type: LOADING,
    transferId,
  };
}

/**
 * Used by the saga to set the status and store result.
 */
export function success(result) {
  return {
    type: SUCCESS,
    result,
  };
}

/**
 * Used by the saga to set the status and store the error.
 */
export function failure(error) {
  return {
    type: FAILURE,
    error,
  };
}



// WEBPACK FOOTER //
// ./src/services/suspendWire/actions.js